import { useCallback, useEffect, useRef } from 'react';
import { isFunction } from 'lodash';
import webSocket from 'web-socket';

export const useAiImportStatus = () => {
  const unsubscribeToAiImportSuccess = useRef<() => void>();
  const unsubscribeToAiImportError = useRef<() => void>();

  const clearAiImportSubscription = useCallback(() => {
    if (isFunction(unsubscribeToAiImportSuccess.current)) {
      unsubscribeToAiImportSuccess.current();
    }
    if (isFunction(unsubscribeToAiImportError.current)) {
      unsubscribeToAiImportError.current();
    }
  }, []);

  const subscribeToAiImportEvents = useCallback(({
    agreementId,
    onSuccess,
    onFailure,
  }: {
    agreementId: number;
    onSuccess: () => void;
    onFailure: () => void;
  }) => {
    clearAiImportSubscription();

    unsubscribeToAiImportSuccess.current = webSocket.subscribe({
      channelName: `private-agreement-${agreementId}`,
      event: 'agreement:ai_import:status:ready',
      eventCallback: onSuccess,
    });

    unsubscribeToAiImportError.current = webSocket.subscribe({
      channelName: `private-agreement-${agreementId}`,
      event: 'agreement:ai_import:status:failed',
      eventCallback: onFailure,
    });
  }, [clearAiImportSubscription]);

  useEffect(() => () => {
    clearAiImportSubscription();
  }, [clearAiImportSubscription]);

  return {
    subscribeToAiImportEvents,
    clearAiImportSubscription,
  };
};
